/**
 * Bug #489
 * @Author Anupama P
 * @Date 9 Jul 2021
 */
import { Button, faTrashAlt, FontAwesomeIcon } from 'components'
import styles from './style/styles.module.scss'

export default function DeleteIconButton(props) {
    return (
        <Button  className={styles.deleteButton}
        icon={<FontAwesomeIcon icon={faTrashAlt} />}
        {...props}
    />
        
    )
}
